import React from 'react';
import Reveal from './Reveal';

const mono: React.CSSProperties = { fontFamily: "'JetBrains Mono', monospace" };

type Props = { eyebrow: string; tag?: string; title: React.ReactNode; lead?: string; aside?: React.ReactNode };

/** Shared interior-page header: eyebrow / tag rule, headline, and lead paragraph. */
const PageHeader: React.FC<Props> = ({ eyebrow, tag, title, lead, aside }) => (
  <section style={{ background: 'var(--bg)', padding: '4.25rem 1.5rem 4rem' }}>
    <div style={{ maxWidth: 1200, margin: '0 auto' }}>
      <Reveal
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: '3rem',
        }}
      >
        <span style={{ ...mono, fontSize: '.6875rem', letterSpacing: '.18em', textTransform: 'uppercase', whiteSpace: 'nowrap', color: 'var(--ink-3)' }}>
          {eyebrow}
        </span>
        {tag ? (
          <span style={{ ...mono, fontSize: '.6875rem', letterSpacing: '.18em', textTransform: 'uppercase', whiteSpace: 'nowrap', color: 'var(--ink-3)' }}>
            {tag}
          </span>
        ) : null}
      </Reveal>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '2rem 4rem', alignItems: 'flex-end' }}>
        {aside ? (
          <>
            <div style={{ flex: '1 1 560px' }}>
              <Reveal
                as="h1"
                style={{
                  margin: 0,
                  fontWeight: 500,
                  fontSize: 'clamp(2.4rem,4.6vw,3.9rem)',
                  lineHeight: 1.02,
                  letterSpacing: '-.025em',
                  color: 'var(--ink)',
                  textWrap: 'balance',
                } as React.CSSProperties}
              >
                {title}
              </Reveal>
              {lead ? (
                <Reveal as="p" delay={80} style={{ margin: '1.75rem 0 0', maxWidth: '38rem', fontSize: '1.125rem', lineHeight: 1.6, color: 'var(--ink-2)' }}>
                  {lead}
                </Reveal>
              ) : null}
            </div>
            <Reveal delay={100} style={{ flex: '1 1 360px' }}>
              {aside}
            </Reveal>
          </>
        ) : (
          <>
            <Reveal
              as="h1"
              style={{
                flex: '1 1 560px',
                margin: 0,
                fontWeight: 500,
                fontSize: 'clamp(2.4rem,4.6vw,3.9rem)',
                lineHeight: 1.02,
                letterSpacing: '-.025em',
                color: 'var(--ink)',
                textWrap: 'balance',
              } as React.CSSProperties}
            >
              {title}
            </Reveal>
            <Reveal as="p" delay={80} style={{ flex: '1 1 360px', margin: 0, fontSize: '1.125rem', lineHeight: 1.6, color: 'var(--ink-2)' }}>
              {lead}
            </Reveal>
          </>
        )}
      </div>
    </div>
  </section>
);

export default PageHeader;
